﻿import { CreateEditGroupPermissionRequest, createPermissionGroup, deletePermissionGroup, editPermissionGroup, GroupPermission, GroupPermissionType, GroupRule, TreeDataNode } from "../../API/GroupPermissions/GroupPermissions";
import { RESTError } from "../../API/RESTError";
import { MainSite } from "../../MainSite";
import { ManagePermissionGroupsPage } from "./ManagePermissionGroupsPage";

export class CreateEditGroupPermissionModal {

    

    private modal: JQuery = null;
    private modalBodyContent: JQuery;
    private deleteModalBodyContent: JQuery;
    private modalSaveButton: JQuery = null;
    private rightRuleSelectorPanel: JQuery = null;
    private viewAndDownloadRadio: JQuery = null;
    private groupNameInput: JQuery = null;

    private tree: Fancytree.Fancytree = null;
    private allTreeNodes: Fancytree.FancytreeNode[] = [];
    private filterInput: JQuery = null;
    private treeData: TreeDataNode[];
    private selectedFancyTreeNode: Fancytree.FancytreeNode;
    private preselectedNodes: Fancytree.FancytreeNode[] = [];
    private preselectedNodeToRemove: Fancytree.FancytreeNode = null;

    //Data to be saved
    private groupPermissionRules: GroupRule[];
    private groupName = "";
    private permissionType: GroupPermissionType = GroupPermissionType.View;

    private refresh: (page: any) => void;
    private parentPage: ManagePermissionGroupsPage;

    constructor(d:TreeDataNode[], refresh: (page: ManagePermissionGroupsPage) => void, parentPage: ManagePermissionGroupsPage) {
        this.treeData = d;
        this.refresh = refresh;
        this.parentPage = parentPage;
        this.groupName = "";
        this.permissionType =GroupPermissionType.View;
    }

    private setupPermissionTree(parent: JQuery) {
        let $table: JQuery = $('<table>').addClass('table table-hover midi_common_table').appendTo(parent);
        $table.append('<colgroup><col width="*"></col><col width="90px"></col><col width="50px"></col></colgroup>');
        $table.append('<thead><tr><th><div class="midi_manageGroupPermissions_table_header_container"><span>Available Permissions</span><div class="midi_manageGroupPermissions_table_header_line"/></div></th></tr></thead>');
        $table.append('<tbody></tbody>');

        let treeOpts: Fancytree.FancytreeOptions = {
            extensions: ["table", "filter"],
            checkbox: false,
            table: {
                indentation: 20,      // indent 20px per node level
                nodeColumnIdx: 0,     // render the node title into the 2nd column
                checkboxColumnIdx: -1  // render the checkboxes into the 1st column
            },
            filter: {
                autoApply: false,
                autoExpand: true,
                counter: false,
                fuzzy: true,
                hideExpanders: true,
                highlight: true,
                mode: 'hide'
            },
            source: this.treeData,
            clickFolderMode: 4,
            click: (event, data) => {
                if (data.targetType == "expander") { //: https://wwwendt.de/tech/fancytree/doc/jsdoc/global.html#FancytreeEvents
                    console.info("NODE CLICK - EXPANDER (IGNORED)", { event: event, data: data });
                    return true; //: otherwise expansion of folders may be prevents further down.
                } else {
                    //disbaled/previously selected nodes cannot be selected again   
                    if (!this.isDisabled(data.node.data as TreeDataNode)) {
                        var oldSelected = this.selectedFancyTreeNode;
                        this.selectedFancyTreeNode = data.node;
                        if (oldSelected) {
                            this.reRenderNode(oldSelected); // to remove highlight from previously selected nodes
                        }
                        this.expandNode(data.node, true);
                    }                                
                }
                return false; 
            },
            renderTitle: (event, data) => {
                this.allTreeNodes.push(data.node);
                let tnd: TreeDataNode = data.node.data as TreeDataNode;
                let selectedTND: TreeDataNode = this.selectedFancyTreeNode ? this.selectedFancyTreeNode.data as TreeDataNode : null;
                var className = this.selectedFancyTreeNode && this.checkIfSelfOrChild(tnd, selectedTND) ? "fancytree-title midi_manageGroupPermissions_modal_selected_fancytree_item" : this.isDisabled(tnd) ? "fancytree-title-disabled" : "fancytree-title";
                
                if (tnd.NodeType == "Region") {
                    return `<span class="` + className + `"><i class="fa fa-fw fa-lg ${MainSite.getAwesomeIconClass('region')}"></i> <strong>${MainSite.escapeString(tnd.RegionLabel)}</strong></span>`;
                } else if (tnd.NodeType == "Station") {
                    return `<span class="` + className + `" title="${MainSite.escapeString(tnd.RegionLabel)}"><i class="fa fa-fw fa-lg  ${MainSite.getAwesomeIconClass('station')}"></i> ${MainSite.escapeString(tnd.StationLabel)}</span>`;
                } else {
                    return `<span class="` + className + `" title="${MainSite.escapeString(tnd.RegionLabel)} / ${MainSite.escapeString(tnd.StationLabel)}"><i class="fa fa-fw  ${MainSite.getAwesomeIconClass('sensor')}"></i> ${MainSite.escapeString(tnd.SensorLabel)}</span>`;
                }
            }
        };      

        $table.fancytree(treeOpts);
        this.tree = $table.fancytree('getTree');
    }

    private checkIfSelfOrChild(tnd: TreeDataNode, n: TreeDataNode): boolean {          
        switch (n.NodeType) {
            case "Region": 
                return n.RegionId === tnd.RegionId;
            case "Station":
                return n.RegionId === tnd.RegionId && n.StationId === tnd.StationId;
            case "Sensor":
                return n.RegionId === tnd.RegionId && n.StationId === tnd.StationId && n.SensorId === tnd.SensorId;        
        }
    }

    private isDisabled(tnd: TreeDataNode): boolean {
        var disabled = false;
        this.preselectedNodes.forEach(psn => {
            let n: TreeDataNode = psn.data as TreeDataNode;
            if (this.checkIfSelfOrChild(tnd, n)) {
                disabled = true;
            }
        });

        return disabled;
    }

    private reRenderNode(node: Fancytree.FancytreeNode) {
        node.renderTitle();
        if (node.hasChildren()) {
            node.children.forEach(ch => {
                this.reRenderNode(ch);
            });
        }
    }

    private expandNode(node: Fancytree.FancytreeNode, expand: boolean): void {
        node.setExpanded(expand);           
        node.renderTitle();
        
        if (node.hasChildren()) {
            node.children.forEach(ch => {
                this.expandNode(ch, expand);
            });
        }
    }

    private gelAllTreeNodes(root: Fancytree.FancytreeNode): void {
        this.allTreeNodes.push(root);

        if (root.hasChildren()) {
            root.children.forEach(ch => {
                this.gelAllTreeNodes(ch);
            });
        }
    }

    public renderModal(pg?: GroupPermission) {
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
            this.selectedFancyTreeNode = null;
            this.preselectedNodeToRemove = null;

            this.preselectedNodes = [];
            this.groupName = "";
        }

        this.modal = $('<div class="modal fade"></div>')
            .appendTo('body');

        var modalDialog = $('<div class="modal-dialog"></div>')
            .appendTo(this.modal);

        var modalContent = $('<div class="modal-content"></div>')
            .appendTo(modalDialog);

        var modalHeaderContent = $('<div class="modal-header"></div>')
            .appendTo(modalContent);

        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>')
            .appendTo(modalHeaderContent);

        if (!pg) {
            $('<h4 class="modal-title">Create Group Permision</h4>')
                .appendTo(modalHeaderContent);
        } else {
            $('<h4 class="modal-title">Edit Group Permission</h4>')
                .appendTo(modalHeaderContent);
        }

        //MODAL BODY
        this.modalBodyContent = $('<div class="modal-body"></div>')
            .appendTo(modalContent);

        //Group Name
        var groupNameContainer = $('<div class="input-group midi_manageGroupPermissions_input_container"> </div>')
            .appendTo(this.modalBodyContent);
        $('<div>Group Name:</div>').appendTo(groupNameContainer);
        this.groupNameInput = $('<input id="midi_ManageGroupPermissions-name-input" class="form-control" type="text" placeholder="Enter a name for this group" />').on('keyup input', (e) => {
            this.groupName = this.groupNameInput.val();
        }).appendTo(groupNameContainer);

        //Permission Type
        var typeSelectionContainer = $('<div class="input-group midi_manageGroupPermissions_input_container">Permission Type: </div>')
            .appendTo(this.modalBodyContent);

        var viewDataRadioContainer = $('<label class="midi_manageGroupPermissions_input_container_checkbox_label"> </label>').appendTo(typeSelectionContainer);
        var viewDataRadio = $('<input name="group_permission_type" id="view_gp" type="radio" value="0">').click(() => { this.permissionType = GroupPermissionType.View }).appendTo(viewDataRadioContainer);
        $('<strong>View Data</strong>').appendTo(viewDataRadioContainer);
        viewDataRadioContainer.click();
        var viewAndDownloadDataRadioContainer = $('<label class="midi_manageGroupPermissions_input_container_checkbox_label"></label>').appendTo(typeSelectionContainer);
        this.viewAndDownloadRadio = $('<input name="group_permission_type" id="view_and_download_gp" type="radio" value="1">').click(() => { this.permissionType = GroupPermissionType.ViewAndDownload }).appendTo(viewAndDownloadDataRadioContainer);
        $('<strong>View & Download Data</strong>').appendTo(viewAndDownloadDataRadioContainer);

        //Rule Selector
        var filterRow = $('<div class="midi_manageGroupPermissions_modal_filter_container"></div>').appendTo(this.modalBodyContent);
        var ruleSelectorPanelsContainer = $('<div class="input-group midi_manageGroupPermissions_panels_container"> </div>').appendTo(this.modalBodyContent);
        var leftRuleSelectorPanel = $('<div class="midi_manageGroupPermissions_rule_selector_panel"></div>').appendTo(ruleSelectorPanelsContainer);
        this.setupPermissionTree(leftRuleSelectorPanel);

        //add filter
        $('<span class="input-group-addon"><i class="fa fa-fw fa-filter"></i></span>').appendTo(filterRow);
        this.filterInput = $('<input type="search" placeholder="Filter..." />').addClass('form-control').appendTo(filterRow);
        $('<button>').appendTo($('<span class="input-group-btn"></span>').appendTo(filterRow)).addClass('btn btn-default').html('<i class="fa fa-fw fa-times"></i> <span class="sr-only">Clear filter</span>').on("click", (e) => {
            $(e.target).blur();
            this.filterInput.val('');
            this.treeApplyFilters();
        });

        this.filterInput.on("keyup", (e) => {
            this.treeApplyFilters();
        });

        var moveButtonsContainer = $('<div class="midi_manageGroupPermissions_move_buttons_container"></div>').appendTo(ruleSelectorPanelsContainer);
        this.rightRuleSelectorPanel = $('<div class="midi_manageGroupPermissions_rule_selector_panel"></div>').appendTo(ruleSelectorPanelsContainer);


        //move right button (add to rules list)
        $('<button class="btn btn-default"><i class="fa fa-lg fa-chevron-right"></i></button>').click(() => {
            if (this.selectedFancyTreeNode) {
                var old = this.selectedFancyTreeNode;
                this.preselectedNodes.push(this.selectedFancyTreeNode);
                this.updatePreSelectedNodePanel(this.rightRuleSelectorPanel);
                this.selectedFancyTreeNode = null;
                this.reRenderNode(old);
            }             
        }).appendTo(moveButtonsContainer);

        //move left button (remove from rules list)
        $('<button class="btn btn-default"><i class="fa fa-lg fa-chevron-left"></i></button>').click(() => {
            var indexToRem = null;
            if (this.preselectedNodeToRemove) {
                this.preselectedNodes.forEach((psn, i) => {
                    var tnd = psn.data as TreeDataNode;
                    var toRem = this.preselectedNodeToRemove.data as TreeDataNode;
                    if (tnd.RegionId === toRem.RegionId && tnd.StationId === toRem.StationId && tnd.SensorId === toRem.SensorId) {
                        indexToRem = i;
                    }
                });
                this.preselectedNodes.splice(indexToRem, 1);
                this.reRenderNode(this.preselectedNodeToRemove);
                this.preselectedNodeToRemove = null;
                this.updatePreSelectedNodePanel(this.rightRuleSelectorPanel);
            }              
        }).appendTo(moveButtonsContainer);
        

        //FOOTER
        var footerClass = pg ? "modal-footer create_edit_pg_footer" : "modal-footer";
        var modalFooterContent = $('<div class="' + footerClass + '"></div>').appendTo(modalContent);

        if (pg) {
            //set up DELETE button
            $('<button type="button" class="btn btn-danger pg_delete_button"> Delete Group</button>').click(() => {
                this.modalBodyContent.hide();
                modalFooterContent.hide();
                this.deleteModalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
                $('<p>Are you sure about deleting permission group: <strong>' + pg.GroupName + '</strong>?</p>').appendTo(this.deleteModalBodyContent);
                $('<p>All users associated with this group will loose those permissions within this group.</p>').appendTo(this.deleteModalBodyContent);
                var deleteFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
                $('<button type="button" class="btn btn-default" > Cancel </button>').click(() => {
                    this.deleteModalBodyContent.remove();
                    deleteFooterContent.remove();
                    this.modalBodyContent.show();
                    modalFooterContent.show();
                }).appendTo(deleteFooterContent);
                $('<button type="button" class="btn btn-danger pg_delete_button"> Delete </button>').click(() => {
                    this.deletePermissionGroup(pg.GroupId);
                }).appendTo(deleteFooterContent);
            }).appendTo(modalFooterContent);
            $('<div class="create_edit_pg_footer_buttons_separator"></div>').appendTo(modalFooterContent);
        }

        $('<button type="button" class="btn btn-default" data-dismiss="modal" > Cancel </button>').appendTo(modalFooterContent);
        //save button
        this.modalSaveButton = $('<button type="button" class="btn btn-success" > Save</button>')
            .appendTo(modalFooterContent)
            .click(() => {
                if (this.groupName !== "" && this.preselectedNodes.length > 0) {
                    var rules: GroupRule[] = []
                    this.preselectedNodes.forEach(psn => {
                        var tnd = (psn.data as TreeDataNode);
                        rules.push({
                            RegionId: tnd.RegionId,
                            StationId: tnd.StationId,
                            SensorId: tnd.SensorId,
                        });
                    });
                    var req: CreateEditGroupPermissionRequest = {
                        GroupName: this.groupName,
                        GroupPermissionType: this.permissionType,
                        GroupRules: rules,
                    };

                    if (pg) {
                        req.GroupId = pg.GroupId;
                    }
                    this.createEditPermissionGroup(req);
                } else {
                    var alertText = this.groupName == "" ? "Group Name cannot be empty. Please enter a name and try again." : "Group Permission must contain at least 1 rule. Please add one and try again."
                    alert(alertText);
                }
            });
                
        //set initial data in case of Edit action
        this.initModalData(pg);

        this.updatePreSelectedNodePanel(this.rightRuleSelectorPanel);

        this.modal.modal('show');
    }

    private initModalData(pg?: GroupPermission) {
        if (pg !== null) {
            this.groupName = pg.GroupName;
            this.groupNameInput.val(pg.GroupName);
            if (pg.GroupPermissionType === GroupPermissionType.ViewAndDownload) {
                this.viewAndDownloadRadio.click();
            }
            pg.GroupRules.forEach(rule => {
                var node = null;
                this.allTreeNodes = [];
                this.gelAllTreeNodes(this.tree.rootNode);
                this.allTreeNodes.forEach(n => {
                    var tnd = n.data as TreeDataNode;
                    if (tnd.RegionId === rule.RegionId && tnd.StationId === rule.StationId && tnd.SensorId === rule.SensorId) {
                        node = n;
                    }
                });

                if (node) {
                    this.preselectedNodes.push(node);
                    this.reRenderNode(node);                  
                }
            });              
        }          
    }

    private updatePreSelectedNodePanel(panel: JQuery) {
        panel.empty();
        var header = $('<div class="midi_manageGroupPermissions_table_header_container"></div>').appendTo(panel);
        $('<span><strong>Selected Permissions</strong></span>').appendTo(header);
        $('<div class="midi_manageGroupPermissions_table_header_line"></div>').appendTo(header);
        var ruleList = $('<ul id="midi_manageGroupPermissions_modal_preselected_nodes_list"></ul>').appendTo(panel);
        
        this.preselectedNodes.forEach(psn => {
            var listItem = $('<li></li>').append(this.getRuleLabelForNode(psn)).appendTo(ruleList);
            listItem.click(() => {
                this.updatePreSelectedList();
                this.preselectedNodeToRemove = psn;
                listItem.addClass('midi_manageGroupPermissions_modal_preselected_nodes_list_item_selected');
            });
        });
    }

    private updatePreSelectedList() {
        $('#midi_manageGroupPermissions_modal_preselected_nodes_list li').each(function () {
            $(this).removeClass('midi_manageGroupPermissions_modal_preselected_nodes_list_item_selected');
        });
    }

    private getRuleLabelForNode(node: Fancytree.FancytreeNode): JQuery {
        let tnd: TreeDataNode = node.data as TreeDataNode;
        switch (tnd.NodeType) {
            case "Region":
                return $("<span>All data in region <strong>" + tnd.RegionLabel + "</strong></span>");
            case "Station":
                return $("<span>All data for station <strong>" + tnd.StationLabel + "</strong></span>");
            case "Sensor":
                return $("<span><strong>" + tnd.RegionLabel + "</strong> / <strong>" + tnd.StationLabel + "</strong> / <strong>" + tnd.SensorLabel + "</strong></span>");
        }
    }

    private treeApplyFilters(): void {
        let val = MainSite.escapeString($(this.filterInput).val()).toLowerCase();
        this.tree.filterNodes((node: Fancytree.FancytreeNode) => {
            let tnd: TreeDataNode = node.data as TreeDataNode;
            if (node.title.toLowerCase().indexOf(val) >= 0
                || tnd.RegionLabel.toLowerCase().indexOf(val) >= 0
                || (tnd.StationLabel && tnd.StationLabel.toLowerCase().indexOf(val) >= 0)
                || (tnd.SensorLabel && tnd.SensorLabel.toLowerCase().indexOf(val) >= 0)) {
                return true;
            }
            return false;
        });
    }


    private createEditPermissionGroup(pg: CreateEditGroupPermissionRequest) {
        if (pg.GroupId) {
            editPermissionGroup(pg, (err: RESTError) => {
                if (err) {
                    $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating Group Permission: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                    return;
                }
                this.modal.modal('hide');
                this.refresh(this.parentPage);
            });
        } else {
            createPermissionGroup(pg, (err: RESTError) => {
                if (err) {
                    $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Creating Group Permission: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                    return;
                }
                this.modal.modal('hide');
                this.refresh(this.parentPage);
            });
        }          
    }

    private deletePermissionGroup(groupId) {
        deletePermissionGroup(groupId, (err: RESTError) => {
            if (err) {
                $('<div class="alert alert-danger midi_ManageUsersPage_warningBox">Error Deleting Group Permission: ' + err.Message + '</div>').appendTo(this.modalBodyContent);
                return;
            }
            this.modal.modal('hide');
            this.refresh(this.parentPage);
        });
    }
}